import Button from '@mui/material/Button'
import { PHASES } from '../reducer'
import { t } from '@lingui/core/macro'

export const DecoratedActions = ({ fileName, currentPhase, handleClose, onClickUpload }) => (
  <>
    {[PHASES.START, PHASES.ERROR].includes(currentPhase) && (
      <div>
        <Button
          onClick={handleClose}
          color="primary"
          style={{ marginRight: '8px' }}
          data-testid="cancel-button"
        >
          {t`Cancel`}
        </Button>
        <Button
          name="upload"
          onClick={onClickUpload}
          variant="contained"
          color="primary"
          autoFocus
          disabled={!fileName}
          data-testid="upload-button"
        >
          {t`Upload`}
        </Button>
      </div>
    )}
    {currentPhase === PHASES.SUCCESS && (
      <Button onClick={handleClose} color="primary" data-testid="close-button">
        {t`Close`}
      </Button>
    )}
  </>
)
